import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface PaymentLinkData {
  siteIdentifier: string;
  folioId: string;
  bookingNumber: string;
  amount: string;
  endAt: string;
  type: string;
  paymentRefId?: string | null;
}

interface PrepaymentState {
  paymentId: string | null;
  setPaymentId: (id: string | null) => void;
  resetPaymentId: () => void;
  prePaymentSlug: string | null;
  setPrePaymentSlug: (slug: string | null) => void;
  resetPrePaymentSlug: () => void;
  paymentLink: PaymentLinkData | null;
  setPaymentLink: (data: PaymentLinkData | null) => void;
  resetPaymentLink: () => void;
  hasHydrated: boolean;
  setHasHydrated: (state: boolean) => void;
  paymentStatus: string | null;
  setPaymentStatus: (status: string | null) => void;
}

export const usePrepaymentStore = create<PrepaymentState>()(
  persist(
    (set) => ({
      paymentId: null,
      paymentStatus: null,
      prePaymentSlug: null,
      paymentLink: null,
      setPrePaymentSlug: (slug: string | null) => {
        set({ prePaymentSlug: slug });
      },
      setPaymentId: (id: string | null) => {
        set({ paymentId: id });
      },
      setPaymentStatus: (status: string | null) => {
        set({ paymentStatus: status });
      },
      setPaymentLink: (data: PaymentLinkData | null) => {
        set({ paymentLink: data });
      },
      resetPrePaymentSlug: () => {
        set({ prePaymentSlug: null });
      },
      resetPaymentId: () => {
        set({ paymentId: null });
      },
      resetPaymentLink: () => {
        set({ paymentLink: null });
      },
      hasHydrated: false,
      setHasHydrated: (state: boolean) => set({ hasHydrated: state }),
    }),
    {
      name: "prepayment-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
